import styled from 'styled-components';

const UserDetailLayout = styled.div`
  .detail-user-icon:hover {
    color: #2e74ff;
  }
  .record-cover {
    max-height: 300px;
    overflow: scroll;
  }

  .cover-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .space-group {
      .spaceRecordDate {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 12px;
      }
    }

    .cover-export {
      Button {
        margin-right: 15px;
      }
    }
  }
`;

export default UserDetailLayout;
